import React from 'react';
import logo from "../assets/images/ARCIUM_Final_Brand_LANDSCAPE-removebg-preview.png";
import useAOS from '../shared/useAos';
import img from '../assets/images/Projekt_4/bg1.jpg'
import SplitText  from '../shared/SplitText';

export default function Banner1() {
  const handleAnimationComplete = () => {
  console.log('All letters have animated!');
};


    useAOS()
    return (
    <div className="w-full bg-blend-soft-light bg-buttonHover opacity-100 h-screen bg-white bg-cover bg-center bg-home-bg">
      <section 
        data-aos="fade-left"
        data-aos-delay="300"
        data-aos-duration="600"
        className="flex flex-col items-center justify-center text-center px-4 py-80 animate-fade overflow-hidden"
      >
        <img src={logo} alt="" />
             <SplitText
                text="Where vision meets structure"
                className="text-gray-400 font-orbitron text-lg md:text-4xl w-4/5 md:w-full mt-4"
                delay={100}
                duration={0.6}
                ease="power3.out"
                splitType="chars"
                from={{ opacity: 0, y: 40 }}
                to={{ opacity: 1, y: 0 }}
                threshold={0.1}
                rootMargin="-100px"
                textAlign="center"
                onLetterAnimationComplete={handleAnimationComplete}
              />     
      </section>
    </div>  
    )
}
